/**
 * @flow
 * @relayHash 9f45af40d7d3b7220163efbfff75e0a5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AcceptReminderForEventInput = {|
  token: string
|};
export type AcceptReminderForEventMutationVariables = {|
  input: AcceptReminderForEventInput
|};
export type AcceptReminderForEventMutationResponse = {|
  +acceptReminderForEvent: ?{|
    +status: ?string
  |}
|};
export type AcceptReminderForEventMutation = {|
  variables: AcceptReminderForEventMutationVariables,
  response: AcceptReminderForEventMutationResponse,
|};
*/


/*
mutation AcceptReminderForEventMutation(
  $input: AcceptReminderForEventInput!
) {
  acceptReminderForEvent(input: $input) {
    status
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AcceptReminderForEventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "acceptReminderForEvent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AcceptReminderForEventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AcceptReminderForEventMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AcceptReminderForEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AcceptReminderForEventMutation",
    "id": null,
    "text": "mutation AcceptReminderForEventMutation(\n  $input: AcceptReminderForEventInput!\n) {\n  acceptReminderForEvent(input: $input) {\n    status\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '50559ee71645889f9a112b53538ecceb';

module.exports = node;
